// @flow
import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { CheckoutButton as Button } from 'app/common/layouts/commonShop';
import Tooltip from 'app/common/ui/Tooltip';


type Props = {
  className?: string,
  submitting?: boolean,
  onClick: (e: SyntheticEvent<HTMLElement>) => void,
  disabled?: boolean,
}

const CheckoutButton = ({ className, submitting, onClick, disabled }: Props) => {
  const currentShippingId: number = useSelector(state => state.shop.order.shipping.currentShippingId, shallowEqual);

  const loadingDeliveryPoints: boolean = useSelector(state => state.shop.order.deliveryPoints.loading, shallowEqual);

  const loadingShipping: boolean = useSelector(state => state.shop.order.shipping.loading, shallowEqual);

  const cartErasing: boolean = useSelector(state => state.shop.cart.loading, shallowEqual);

  const locked = (disabled
    || loadingDeliveryPoints
    || loadingShipping
    || !currentShippingId
    || cartErasing);

  return (
    <div className={className}>
      <Button onClick={onClick} disabled={submitting || locked}>
        {submitting
          ? 'Оформление...'
          : <Tooltip
            text={!currentShippingId ? 'Нет доступных способов получения.' : ''}
          >
            {'Оформить'}
          </Tooltip>}
      </Button>
    </div>
  );
};

export default CheckoutButton;
